<script lang="ts" setup>
import UtilButton from '@/components/util/UtilButton.vue'
import IconRefresh from '@/components/icons/IconRefresh.vue'

withDefaults(defineProps<{ message?: string }>(), {
  message: 'Something went wrong loading this section.'
})

const reloadPage = () => {
  window.location.reload()
}
</script>

<template>
  <section class="async-error-container">
    <p>{{ message }}</p>
    <UtilButton class="refresh-button" @click="reloadPage">
      <span>Refresh Page</span>
      <IconRefresh class="refresh-button__icon" />
    </UtilButton>
  </section>
</template>

<style lang="scss" scoped>
.async-error-container {
  padding: 1.25rem 1.5rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  gap: 1rem;
  display: flex;
  justify-content: space-between;
  color: var(--red500);
  border-radius: var(--border-radius-4);
  border: 1px solid var(--red100);
}

.refresh-button {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.refresh-button__icon {
  width: 1rem;
  height: 1rem;
}
</style>
